

























































































































































import {Component, Mixins} from 'vue-property-decorator';
import {
  CodeRetrieveResponse, CodesRetrieveResponse, WhoddAiCodeRetrieveResponse, WhoddListInfo, WhoddRetrieveRequest,
  WhoddRetrieveResponse,
  WhoddSelectDialogRequest
} from '@/model/CommonModel';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import TextInput from '@/components/input/TextInput.vue';
import SelectDialogMixin from '@/components/dialog/SelectDialogMixin';
import IconButton from '@/components/button/IconButton.vue';
import DataTable from '@/components/table/DataTable.vue';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import DefaultFormMixin from '@/views/DefaultFormMixin';
import BooleanCheckboxInput from '@/components/input/BooleanCheckboxInput.vue';
import SelectInput from '@/components/input/SelectInput.vue';
import AutocompleteInput from '@/components/input/AutocompleteInput.vue';
import CommonApi from '@/api/CommonApi';
import AiCodingApi from '@/api/AiCodingApi';
import AiCodingDialogMixin from '@/components/dialog/AiCodingDialogMixin';

@Component({
               components: {
                   BooleanCheckboxInput, TextInput, CommonPromptDialog, DataTable,
                   CommonButton, IconButton, SelectInput, AutocompleteInput
               },
               mixins: [DefaultComponentMixin, DialogEventsMixin, SelectDialogMixin, DefaultFormMixin, AiCodingDialogMixin]
           })
export default class CaseWhoddSelectDialog extends Mixins(DialogEventsMixin, SelectDialogMixin, DefaultComponentMixin,
                                                          DefaultFormMixin, AiCodingDialogMixin) {
    private versionName: string = '';
    private errMsg: string = '';
    private whoddTypes: CodeRetrieveResponse[] = [];
    private countries: CodeRetrieveResponse[] = [];
    private values: WhoddListInfo[] = [];
    private isAiRecommendation: boolean = false;
    private form: WhoddRetrieveRequest = {
        whoddType: '',
        version: '',
        searchText: '',
        genOrPre: '',
        genAndPre: '',
        exactMatch: '',
        countryCode: null
    };

    private onSelect: (row: WhoddListInfo) => void;

    get getTitle() {
        return this.$t('message.case.whodd.caseWhoddSelectDialog.title', {version: this.versionName});
    }

    get getValues() {
        return this.values;
    }

    get isLoading() {
        return this.loading;
    }

    get getWhoddTypes() {
        return this.whoddTypes;
    }

    get getCountries() {
        return this.countries;
    }

    get isGenAndPreDisabled() {
        return this.form.genOrPre === 'Y';
    }

    get isGenOrPreDisabled() {
        return this.form.genAndPre === 'Y';
    }

    get isSearchTextMaxlengthExceed() {
        return this.form.searchText.length > this.maxLength;
    }

    get getSearchText() {
        return this.form.searchText;
    }

    get getAlert() {
        return this.errMsg;
    }

    public getRowStyle(color: string): any {
        return {'background-color': this.getRowColor(color)};
    }

    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showCaseWhoddSelectDialog', (params: WhoddSelectDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideCaseWhoddSelectDialog', () => this.close());
    }

    public show(request: WhoddSelectDialogRequest) {
        this.errMsg = this.$t('message.case.dialog.alert').toString();
        this.versionName = request.whoddVersionInfo.version;
        this.onSelect = request.onSelect;
        this.whoddTypes = request.whoddTypes;
        this.form.version = request.whoddVersionInfo.tableVersion;
        this.form.countryCode = request?.reporterCdmsMappingCountry;
        this.form.whoddType = this.whoddTypes[0]?.codeValue;
        this.maxLength = request.maxLength;

        this.isAiRecommendation = false;
        this.loading = false;

        // Ai Coding 시 사전 검증
        if (request.isAiCoding) {
            this.isAiRecommendation = true;
            this.form.searchText = '';
            this.retrieveRecommendedWhoddCodes(false)
                .then(() => {
                    this.visible = true;
                    this.retrieveInitApis(request);
                });
        } else {
            this.visible = true;
            this.retrieveInitApis(request);
        }
    }

    public retrieveInitApis(request: WhoddSelectDialogRequest) {
        const shouldCallApis: Array<Promise<any>> = [
            this.retrieveCountries()
        ];

        if (request.isAiCoding && this.values.length === 0) {
            shouldCallApis.push(this.retrieveRecommendedWhoddCodes(true));
        } else if (this.getSearchText.length > 0) {
            shouldCallApis.push(this.retrieveWhoddCodes());
        }

        this.loading = true;
        Promise.all(shouldCallApis)
            .finally(() => this.loading = false);
    }

    public retrieveCountries() {
        return CommonApi.retrieveWhoddCountries(this.form.version)
                      .then((res: CodesRetrieveResponse) => {
                          if (!res.success) {
                              return Promise.reject(res.errMsg);
                          }

                          this.countries = res.data.codeList;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg));
    }

    private retrieveRecommendedWhoddCodes(shouldUsePooling: boolean) {
        const params = {
          ...Object.fromEntries(Object.entries(this.form ?? {})
              .filter(([_, v]) => this.StringUtils.hasValue(v))),
          whoddType: 'MPID',
          countryCode: null,
          shouldUsePooling
        };
        const caseKey = Number(this.$route.params.caseKey);
        const rowNo = Number(this.$route.params.rowNo);

        return AiCodingApi.retrieveRecommendedWhoddCodes(caseKey, rowNo, params)
                      .then((res: WhoddAiCodeRetrieveResponse) => {
                          return this.handleRetrieveRecommendCodesSuccess(
                            res,
                            data => this.values = data.recommendedCodes,
                            this.close
                          );
                      })
                      .catch(({errMsg, errCode}) => {
                          return this.handleRetrieveRecommendCodesError(errMsg, errCode, this.close, this.afterRequestFail);
                      });
    }

    protected onSearch() {
        this.errMsg = this.$t('message.case.whodd.caseWhoddSelectDialog.alert').toString();

        if (this.getSearchText.length < 2) {
            this.values = [];
            return;
        } else if (this.getSearchText.length === 2) {
            if (this.isNumberOrKorean(this.getSearchText)) {
                this.errMsg = this.$t('message.case.dialog.alert').toString();
                this.retrieveWhoddCodes();
            }
        } else {
            this.errMsg = this.$t('message.case.dialog.alert').toString();
            this.retrieveWhoddCodes();
            return;
        }
    }

    public isNumberOrKorean(str: string): boolean {
        const koreanAndNumber = /[ㄱ-ㅎㅏ-ㅣ가-힣0-9]/;
        return koreanAndNumber.test(str);
    }

    public retrieveWhoddCodes() {
        this.loading = true;
        this.isAiRecommendation = false;
        const params = Object.fromEntries(Object.entries(this.form ?? {})
                                                .filter(([_, v]) => this.StringUtils.hasValue(v)));
        return CommonApi.retrieveWhoddCodes(params)
                      .then((res: WhoddRetrieveResponse) => {
                          if (!res.success) {
                              return Promise.reject(res.errMsg);
                          }
                          this.values = res.data;
                      })
                      .catch((errMsg) => this.afterRequestFail(errMsg))
                      .finally(() => this.loading = false);
    }

  public retrieveAIWhoddCodes() {
    this.loading = true;
    const params = Object.fromEntries(Object.entries(this.form ?? {})
        .filter(([_, v]) => this.StringUtils.hasValue(v)));
    return CommonApi.retrieveWhoddCodes(params)
        .then((res: WhoddRetrieveResponse) => {
          if (!res.success) {
            return Promise.reject(res.errMsg);
          }
          this.values = res.data;
        })
        .catch((errMsg) => this.afterRequestFail(errMsg))
        .finally(() => this.loading = false);
  }

    public onInput() {
        if (this.isSearchTextMaxlengthExceed) {
            this.errMsg = this.$t('message.case.dialog.directInputMaxlengthExceed').toString();
            return;
        }

        this.onRowClick({
                            medicinalProductId: this.getSearchText,
                            drugCode: this.getSearchText,
                            isDirectInput: true
                        });
    }

    public onRowClick(row: any) {
        if (this.onSelect) {
            this.onSelect(row);
        }

        this.close();
    }

    public getRowColor(color: string) {
        color = color.toUpperCase();
        switch (color) {
            case 'BLUE':
                return '#CFD6E2';
            case 'GRAY':
                return '#E1E1E1';
            case 'GREEN':
                return '#CCFFCC';
            default:
                return color;
        }
    }

    public close() {
        this.visible = false;
    }

    public afterClosed() {
        this.values = [];
        this.loading = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showCaseWhoddSelectDialog');
        this.$modal.getEventBus().$off('hideCaseWhoddSelectDialog');
    }
}
